import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import classNames from "classnames";
import Icon from "../../shared_modules/common/icons/Icon";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

const element = {
  name: "emailConfirmation",
  id: "pf-contact-email-confirm",
  label: "Confirm Email Address",
  colLabelClassName: "label",
  colFieldClassName: "field",
  colValidationClassName: "messaging",
  maxLength: 50,
};

const componentMsgs = {
  emailsNotMatch: "Email address fields don't match.",
  emailConfirmRequiredMsg: "Confirm Email is required.",
  helperText:
    "You will need to verify your email address before your provider can accept your application.",
};

class EmailConfirm extends Component {
  static defaultProps = {
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
    validationState: {
      emailFieldsTouched: false,
    },
    element,
  };

  initMsgObj = () => {
    const msgData = {
      errors: {},
      info: {},
    };

    msgData.errors[element.name] = {};
    msgData.info[element.name] = {};

    return msgData;
  };

  updateParentSection(ev, data) {
    const { onEventCallback } = this.props;
    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, data);
    }
  }

  compareEmailAddresses = (emailData, confirmedEmail) => {
    const { emailsNotMatch } = componentMsgs;
    const { value: email } = emailData;

    if (emailData.isValid && email !== confirmedEmail) {
      return {
        type: "error",
        msg: emailsNotMatch,
        id: element.id,
        slug: element.name,
      };
    }
  };

  checkRequired = (currentVal) => {
    const { emailConfirmRequiredMsg } = componentMsgs;
    return (
      !currentVal && {
        type: "error",
        msg: emailConfirmRequiredMsg,
        id: element.id,
        slug: element.name,
      }
    );
  };

  state = {
    msgData: this.initMsgObj(),
  };

  handlePaste(ev) {
    ev.preventDefault();
  }

  handleFocus = (ev) => {
    const { fieldMetadata } = this.props;
    const msgData = this.initMsgObj();
    const { helperText } = componentMsgs;
    fieldMetadata.status = "";
    msgData.info = {
      [element.name]: {
        type: "info",
        msg: helperText,
        id: element.id,
        slug: element.name,
      },
    };

    if (window && window.chrome) {
      ev.target.setAttribute("autocomplete", "new-password"); // disable chrome's autocomplete
    }
    this.setState({ msgData });
  };

  handleChange = (ev) => {
    const { fieldMetadata, emailFieldMetadata } = this.props;

    let msgData = this.initMsgObj();
    this.dirty = true;

    const { value: currentEmail } = emailFieldMetadata;

    const {
      target: { value },
    } = ev;
    const eventRecord = { ...ev };
    fieldMetadata.value = value;

    if (ev.type === "blur") {
      let errMessage = this.checkRequired(fieldMetadata.value);
      if (!errMessage) {
        errMessage = this.compareEmailAddresses(
          emailFieldMetadata,
          currentEmail,
        );
      }

      if (errMessage) {
        fieldMetadata.isValid = false;
        fieldMetadata.status = "invalid";
        msgData.errors = {
          [element.name]: errMessage,
        };
      } else {
        fieldMetadata.isValid = true;
        fieldMetadata.status = "";
      }

      this.setState({ msgData }, () => {
        this.updateParentSection(eventRecord, fieldMetadata);
      });
    }
  };

  canValidate = () => {
    const { formState } = this.props;

    return this.dirty || formState.hasValidated;
  };

  render() {
    const { colLayout, fieldMetadata, emailFieldMetadata } = this.props;

    const { msgData } = this.state;
    const iconProps = {};
    const currentEmail = fieldMetadata.value;

    let errMessage;
    if (this.canValidate()) {
      errMessage = this.checkRequired(currentEmail);
      if (!errMessage) {
        errMessage = this.compareEmailAddresses(
          emailFieldMetadata,
          currentEmail,
        );
      }

      if (errMessage) {
        msgData.errors[element.name] = errMessage;
        fieldMetadata.status = "invalid";
        fieldMetadata.isValid = false;
      } else {
        fieldMetadata.status = "";
        msgData.errors[element.name] = {};
        fieldMetadata.isValid = true;
      }
    }

    if (fieldMetadata.isValid && emailFieldMetadata.isValid) {
      iconProps.type = "success";
    }

    const confirmClasses = classNames("email-confirmation", {
      invalid: errMessage,
    });

    return (
      <Row className={element.id}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label id={`${element.id}-label`} htmlFor={element.id}>
            {element.label}
          </label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <input
            id={element.id}
            name={element.name}
            onChange={this.handleChange}
            onBlur={this.handleChange}
            onFocus={this.handleFocus}
            className={confirmClasses}
            onPaste={this.handlePaste}
            defaultValue={fieldMetadata.value}
            type="email"
            maxLength={element.maxLength}
            autoComplete="off"
          />
          <Icon {...iconProps} />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[3]}>
          <ValidationMsg
            who={element.name}
            filterFields={[element.name]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

EmailConfirm.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
  emailFieldMetadata: PropTypes.object.isRequired,
  validationState: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
};

export default EmailConfirm;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');